import { useEffect, useState, useCallback } from 'react'

export const useAddressFilter = ({
  districts = [],
  towns = [],
  cityCode,
  districtCode
}) => {
  const [filteredDistricts, setFilteredDistricts] = useState([])
  const [filteredTowns, setFilteredTowns] = useState([])

  const mapOption = (item) => ({
    ...item,
    label: item.title || item.name,
    value: item.code
  })

  const filterDistrictsByCity = useCallback(
    (code) => {
      if (!code || !districts.length) {
        setFilteredDistricts([])
        setFilteredTowns([])
        return
      }

      const result = districts
        .filter(
          d =>
            d.city_code === code ||
            d.parent_code === code
        )
        .map(mapOption)

      setFilteredDistricts(result)
      setFilteredTowns([])
    },
    [districts]
  )

  const filterTownsByDistrict = useCallback(
    (code) => {
      if (!code || !towns.length) {
        setFilteredTowns([])
        return
      }

      const result = towns
        .filter(
          t =>
            t.district_code === code ||
            t.parent_code === code
        )
        .map(mapOption)

      setFilteredTowns(result)
    },
    [towns]
  )

  /**
   * 🔥 AUTO FILTER KHI EDIT
   */
  useEffect(() => {
    if (cityCode) {
      filterDistrictsByCity(cityCode)
    }
  }, [cityCode, filterDistrictsByCity])

  useEffect(() => {
    if (districtCode) {
      filterTownsByDistrict(districtCode)
    }
  }, [districtCode, filterTownsByDistrict])

  const resetAddressFilter = () => {
    setFilteredDistricts([])
    setFilteredTowns([])
  }

  return {
    filteredDistricts,
    filteredTowns,
    filterDistrictsByCity,
    filterTownsByDistrict,
    resetAddressFilter
  }
}
